export default "__VITE_ASSET__sZrxSGmu__"